//* For quiz component
export const CHECK_ANSWER = "CHECK_ANSWER";
export const CHOOSE_RADIO = "CHOOSE_RADIO";

//* For alert component
export const ERROR = "error";
export const SUCCESS = "success";
export const INFO = "info";
export const WARNING = "warning";
